"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentSlotList = exports.AppointmentSlotListContainer = exports.StyledFilterInfoContainer = exports.ApptsUpToDateMsg = exports.NoMoreApptsMsg = exports.LoadMoreBtnContainer = exports.List = exports.Header = exports.StyledRowContainer = exports.Container = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const framer_motion_1 = require("framer-motion");
const EASE = 'ease-out';
exports.Container = styled_1.default.div `
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  > p:first-of-type {
    margin-top: 0;
  }

  > div:first-of-type {
    padding-bottom: ${({ isAboveMd }) => isAboveMd ? (0, ui_theme_1.fromTheme)('spacing_xlarge') : (0, ui_theme_1.fromTheme)('spacing_large')};
    padding-top: ${({ isAboveMd }) => isAboveMd ? (0, ui_theme_1.fromTheme)('spacing_xlarge') : (0, ui_theme_1.fromTheme)('spacing_large')};
  }
`;
exports.StyledRowContainer = (0, styled_1.default)('div') `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.Header = (0, styled_1.default)('div') `
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;

  h5 {
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
    margin: 0;
    padding: 2px 0 0 0;
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
  }
`;
exports.List = (0, styled_1.default)(framer_motion_1.motion.ul) `
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: flex-start;
  list-style: none;
  padding: 0;
  flex: 1;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  transition: max-height 0.2s ${EASE};
  flex-wrap: wrap;
`;
exports.LoadMoreBtnContainer = (0, styled_1.default)('div') `
  button {
    width: 100%;
  }
`;
exports.NoMoreApptsMsg = (0, styled_1.default)('div') `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  text-align: center;
`;
exports.ApptsUpToDateMsg = (0, styled_1.default)('div') `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  text-align: center;
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_small')};
`;
exports.StyledFilterInfoContainer = (0, styled_1.default)('p') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  margin: 0;
`;
exports.AppointmentSlotListContainer = styled_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_xxlarge')};
`;
exports.AppointmentSlotList = styled_1.default.li `
  display: flex;
  flex-direction: column;
  width: 98px;
  flex-shrink: 1;

  & > button {
    margin: 0;
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;
//# sourceMappingURL=styles.js.map